import { Component, computed, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Services } from "src/app/services/api.service"
import { GlobalConstants } from "../../common/global";
import { CommonModule, DecimalPipe } from '@angular/common';
import { AccordionItemComponent } from 'src/app/components/accordion/accordion-item.component';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import { EventsService } from 'src/app/services/getEvents';
import { OrderService } from 'src/app/services/getOrder.service';
import { ACTION_ID } from 'src/app/common/constants';
import { SvgPanZoomService } from './svg-pan-zoom.service';
import { TranslateModule } from '@ngx-translate/core';
import { HeroEventComponent } from 'src/app/components/hero-event/hero-event.component';
import { AccordionComponent } from 'src/app/components/accordion/accordion.component';
import { LoaderComponent } from 'src/app/components/loader/loader.component';
import { CartInfoBoxComponent } from 'src/app/components/cart-info-box/cart-info-box.component';
import { ModalCheckBarcodeComponent } from 'src/app/components/modal-check-barcode/modal-check-barcode.component';
import { EventDetailsComponent } from './sport/event-details/event-details.component';
import { UsersFormFieldsComponent } from "../../components/users-form-fields/users-form-fields.component";
import { GetUserProfileService } from 'src/app/services/getUserProfile.service';
import { PaymentComponent } from "../../components/payment/payment.component";
import { getPriceColors } from './sport/price-colors.constant';
import { AppConfig } from 'src/app/common/app-config/app-config.interface';
import { AppConfigService } from 'src/app/common/app-config/app-config.service';
import { ModalService } from 'src/app/services/modal.service';
import { ModalNames } from 'src/app/common/modal.config';
import { ErrorMessageService } from 'src/app/services/error-message.util';
import { SeatValidationService } from 'src/app/services/seat-validation.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Order } from 'src/app/common/event.model';
import { NavigationCartService } from 'src/app/components/navigation-cart/navigation.cart.service';
import { filter, Subscription } from 'rxjs';
import { NotificationComponent } from 'src/app/components/notification/notification.component';
import { getNotificationConfig } from 'src/app/utils/notification-config.util';
import {toSignal} from "@angular/core/rxjs-interop";

@Component({
  selector: 'app-event',
  templateUrl: `./${environment.pageFolder}/event.${environment.pageFolder}.component.html`,
  styleUrls: [`./${environment.pageFolder}/event.${environment.pageFolder}.component.sass`],
  providers: [ Services, DecimalPipe],
  standalone: true,
  imports: [CommonModule, TranslateModule, HeroEventComponent, AccordionComponent, AccordionItemComponent, LoaderComponent, CartInfoBoxComponent, ModalCheckBarcodeComponent, EventDetailsComponent, UsersFormFieldsComponent, PaymentComponent, NotificationComponent]
})

export class EventComponent implements OnInit {
  @ViewChild(AccordionItemComponent) child: AccordionItemComponent = new AccordionItemComponent;
  ticketCounter: number = 1;
  selectedSector: string | undefined;
  selectedSectorAll: any;
  selectedModal: string = "";
  svg: any;
  groups: any = [];
  connId: any = environment.connId;
  eventId: number;
  actionId: number;
  hashedId: string = "";
  cart: Order | null = null;
  isLogged: boolean = false;
  orderId: number = 0;
  maxAllowedTickets: number = 4;
  ticketNumberCount = sessionStorage.getItem("ticketNumber");
  activeEvent: boolean = false;
  eventAction: any;
  allEvents: any;
  event: any;
  errorMessage: string = "";
  loader = document.getElementById("loader-container");
  selectedEvent: any;
  selectedEventAction: any;
  hasFreeTicketsForMembers: boolean = false;
  errorWhenCombiningTwoDifferentTypesOfTickets: boolean = false;
  errorWhenCombiningTwoDifferentTypesOfTicketsMessage: string = "";
  hasPayment: any;
  seats: any;
  sectorNum: any;
  selectedSeats: any = [];
  sector: any;
  viewBox: string = "";
  initialViewBox: string = "";
  svgWidth: number = 0;
  svgHeight: number = 0;
  infoMessageSeats: string = "";
  seatsPrice: any;
  pricesForMembers: any;
  memberPricesMap = new Map<number, number>();
  showSvg: boolean = false;
  showModalCheckBarcode: boolean = false;
  isValidBarcode: boolean = false;
  addToCartData = {
    group: "",
    sector: "",
    id: "",
    isNumbered: false
  }
  ACTION_ID = ACTION_ID;
  private isPanning = false;
  private isDragging = false;
  @ViewChild('svgElement') svgElement: ElementRef<SVGSVGElement>;
  @ViewChild('panzoomContainer') panzoomContainer: ElementRef<HTMLDivElement>;
  ifSeatsAreLoading: boolean = false;
  cartIsLoaded: boolean = false;
  showSectorsView: boolean = false;
  customerProfile: any;
  showSeats: boolean = false;
  showPayment: boolean = false;
  appConfig: AppConfig;
  miscInnerHtml!: SafeHtml;
  stageInnerHtml!: SafeHtml;
  public readonly modalNamesEnum = ModalNames;
  readonly isAutoSelectionTicketsModalOpen = computed(() => this.modalService.modalsState().get(ModalNames.AutoSelectionTickets) ?? false);
  readonly isSeatMapSelectionTicketsModalOpen = computed(() => this.modalService.modalsState().get(ModalNames.SeatMapSelectionTickets) ?? false);
  @ViewChild('cart') cartEl!: ElementRef<HTMLDivElement>;
  redirectUrlFromParent: string = "user-profile/transactionCompleted";
  redirectErrorUrlFromParent: string = '';
  private routeSub!: Subscription;

  zoomFactor = 1.1;
  minZoom = 0.5;
  maxZoom = 2;
  currentZoom = 1;
  private initialDistance: number = 0;
  routeSubscription: any;
  formFieldsKey = 0;
  showNotification: boolean = false;
  bodyText: string = '';

  memberExclusiveMap: Record<string | number, boolean> = {};
  showLegendUnavailable = false;
  showLegendAvailable = false;
  showLegendMembers = false;

  private readonly currentOrder = toSignal(this.orderService.order$, { initialValue: null as Order | null });
  readonly isTransactionLocked = computed(() => !!this.currentOrder()?.transactionInfo.isLocked);

  constructor(
    public Services: Services,
    private _decimalPipe: DecimalPipe,
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private eventsService: EventsService,
    private orderService: OrderService,
    public svgPanZoomService: SvgPanZoomService,
    private userProfileService: GetUserProfileService,
    private appConfigService: AppConfigService,
    public modalService: ModalService,
    private readonly errorMessageService: ErrorMessageService,
    private seatValidationService: SeatValidationService,
    private sanitizer: DomSanitizer,
    private navigationCartService: NavigationCartService,
   )
    {
    this.appConfig = this.appConfigService.getConfig();
    this.svgElement = {} as ElementRef<SVGSVGElement>;
    this.panzoomContainer = {} as ElementRef<HTMLDivElement>;

    this.hashedId = this.route.snapshot.paramMap.get('hashedId') || "";
    this.eventId = Number(this.route.snapshot.paramMap.get('eventId'));
    this.actionId = Number(this.route.snapshot.paramMap.get('actionId'));
  }

  ngOnInit(): void {
    this.isLogged = GlobalConstants.isAuth;
    this.showNotificationModal();

    this.routeSub = this.route.paramMap.subscribe(params => {
      this.connId = params.get('connId');
      this.eventId = Number(params.get('eventId'));
      this.actionId = Number(params.get('actionId'));
      this.redirectErrorUrlFromParent = `event/${this.connId}/${this.eventId}/${ACTION_ID.NORMAL}/${this.hashedId}/transactionIncompleted`;

      this.getEventDetails(this.actionId).then(() => {
        this.getCartOnPageLoad();
      });
    });
  }

  getEventDetails(actionId:number) {
    return new Promise((resolve:any) => {
      this.loader!.style.display = "flex";

      this.eventsService.getEvent(this.eventId, actionId, this.hashedId).subscribe((Response: any) => {
        this.activeEvent = true;
        let res:any = Response;
        let resJson = res.data;

        if(resJson.action === null) {
          let hasNormalAction = resJson.additionalActions?.some((action: { id: number; }) => Number(action.id) === ACTION_ID.NORMAL);

          if(hasNormalAction) {
            this.eventsService.event = null;
            this.getEventDetails(ACTION_ID.NORMAL);
            this.router.navigate([`event/${this.connId}/${this.eventId}/${ACTION_ID.NORMAL}/${this.hashedId}`]);
            return;
          }
        }

        if(resJson.action === null) {
          this.eventsService.event = null;
          this.router.navigate([``]);
        }

        this.svg = resJson.svg;
        this.groups = resJson.groups;
        this.eventAction = resJson.action;

        this.memberExclusiveMap = {};
        this.groups?.forEach((group: { sectors: any[]; }) => {
          group.sectors.sort((a, b) => a.ord - b.ord);
        });

        this.buildMemberExclusiveMap();
        this.computeLegendFlags();

        this.event = resJson;
        this.selectedEvent = resJson.event;
        this.selectedEventAction = resJson.action;
        this.maxAllowedTickets = this.event.event.maxTicketsPerTransaction;

        if (this.selectedEvent?.isGroup) {
          this.redirectUrlFromParent = "group-tickets-profile/transactionCompleted";
          this.redirectErrorUrlFromParent = "group-tickets-profile/transactionIncompleted"
        }

        this.hasFreeTicketsForMembers = (this.event.additionalActions?.some((action: { id: number; }) => Number(action.id) === ACTION_ID.FREE_TICKET)
          || Number(this.event?.action?.id) === ACTION_ID.FREE_TICKET);

        if(resJson.svg.sectors.length > 0) {
          this.showSvg = true;
          const misc: string  = this.svg.svgMisc;
          const stage: string = this.svg.svgStage;

          this.miscInnerHtml  = this.sanitizer.bypassSecurityTrustHtml(misc);
          this.stageInnerHtml = this.sanitizer.bypassSecurityTrustHtml(stage);
        }

        this.loader!.style.display = "none";

        this.checkIfUserIsCombiningTwoDifferentActionsId();
        resolve();
      }, (error) => {
        if(error.status === 404 || error.status === 500 || error.status === 400) {
          document.location = `${environment.redirectUrl}`;
        }
      })
    })
  }

  checkIfUserIsCombiningTwoDifferentActionsId() {
    if((this.hasPayment === false && this.actionId === ACTION_ID.NORMAL)) {
      this.errorWhenCombiningTwoDifferentTypesOfTickets = true;
      this.errorWhenCombiningTwoDifferentTypesOfTicketsMessage = this.errorMessageService.getErrorMessage('freeTicketsInCart');
    } else if((this.hasPayment && this.actionId === ACTION_ID.FREE_TICKET)) {
      this.errorWhenCombiningTwoDifferentTypesOfTickets = true;
      this.errorWhenCombiningTwoDifferentTypesOfTicketsMessage = this.errorMessageService.getErrorMessage('ticketsInCartWithPrice');
    } else {
      this.errorWhenCombiningTwoDifferentTypesOfTickets = false;
      this.errorWhenCombiningTwoDifferentTypesOfTicketsMessage = '';
    }
  }

  getCartOnPageLoad():any {
    let orderIdFromLocalStorage = localStorage.getItem("orderId");
    let orderIdEventIdFromLocalStorage = localStorage.getItem("orderIdEventId");
    let orderIdFromLastOrder;

    if(GlobalConstants.isAuth) {
      const lastOrder$ = this.navigationCartService.getLastOrder();

      if (typeof lastOrder$ === 'number') {
        orderIdFromLastOrder = lastOrder$;
      } else if (lastOrder$ && typeof lastOrder$.pipe === 'function') {
        lastOrder$
        .pipe(
          filter(response => response.data != null),
        )
        .subscribe({
          next: (response) => {
            orderIdFromLastOrder = response.data;
          }
        });
      }
    }

    if(orderIdFromLastOrder) {
      this.orderId = orderIdFromLastOrder || Number(orderIdFromLocalStorage);
      this.getCart();

      if(environment.pageFolder === 'sport') {
        this.getCustomerProfile();
      }
    } else {
      this.cartIsLoaded = true;
    }

    setTimeout(() => {
      let selectedSector:any = sessionStorage.getItem("selectedSector");
      let group:any = sessionStorage.getItem("group");
      let sector:any = sessionStorage.getItem("sector");

      if(selectedSector !== null) {
        this.openAccordionFromSvg(selectedSector, false);
        this.addToCart(group, sector, selectedSector, false);
      }
    }, 200);
  }

  getCustomerProfile() {
    this.userProfileService.getConnectionUserProfile().subscribe({
      next: (data: any) => {
        this.customerProfile = data.data;
      }
    });
  }

  calculatePrice(i:number, j:number, operator:any) {
    let ticketNumberInput = (<HTMLInputElement>document.getElementById(`ticket-number-id-${i}-${j}`));
    let ticketPriceDefault = (<HTMLInputElement>document.getElementById(`price-default-id-${i}-${j}`));
    let ticketPriceInfo = (<HTMLInputElement>document.getElementById(`price-info-id-${i}-${j}`));
    let maxTicketsInSectorErrMsg:any = document.getElementById(`max-tickets-in-sector-${i}-${j}`);

    if((Number(ticketNumberInput.value) < this.maxAllowedTickets && operator === "+") || (Number(ticketNumberInput.value) > 0 && operator === "-")) {
      maxTicketsInSectorErrMsg.style.display = "none";
      this.errorMessage = "";

      this.groups.map((group:any, groupIndex:number) => {
        group.sectors.map((sector:any, sectorIndex:number) => {
          if(groupIndex === i && sectorIndex === j) {
            let newPrice, newPriceInfo, newValue: any;
            maxTicketsInSectorErrMsg.style.display = "none";
            this.errorMessage = "";

            if(operator === "+") {
              newValue = Number(ticketNumberInput.value) + 1;
            } else if (operator === "-" && Number(ticketNumberInput.value) !== 1) {
              newValue = Number(ticketNumberInput.value) - 1;
            } else {
              newValue = Number(ticketNumberInput.value);
            }

            newPrice = newValue * sector.priceList.amounts[0];
            newPriceInfo = newValue  * sector.priceList.infoPriceList.amounts[0];

            let newPriceWithDecimalSpots = this._decimalPipe.transform(newPrice, '1.2-2');
            let newPriceInfoWithDecimalSpots = this._decimalPipe.transform(newPriceInfo, '1.2-2');

            ticketNumberInput.value  = newValue.toString();
            ticketPriceDefault.innerHTML = newPriceWithDecimalSpots!.toString();
            ticketPriceInfo.innerHTML = newPriceInfoWithDecimalSpots!.toString();
          }
        })
      })
    } else {
      if (maxTicketsInSectorErrMsg) {
        maxTicketsInSectorErrMsg.style.display = "block";
      }
      if(this.maxAllowedTickets === 0) {
        this.errorMessage = this.errorMessageService.getErrorMessage("maxTicketsInCart");
      } else {
        this.errorMessage = this.errorMessageService.getErrorMessage("maxSelectedTicketsInCart");
      }
    }
  }

  calculatePriceFromModal(operater: string) {
    let ticketNumberInput = (<HTMLInputElement>document.getElementById(`ticket-number-modal`));
    if(this.maxAllowedTickets > 0) {
      if((Number(ticketNumberInput.value) < this.maxAllowedTickets && operater === "+") || (Number(ticketNumberInput.value) > 0 && operater === "-")) {
        this.errorMessage = "";
        let newValue: any;
        if(operater === "+") {
          newValue = Number(ticketNumberInput.value) + 1;
        } else if (operater === "-" && Number(ticketNumberInput.value) !== 1) {
          newValue = Number(ticketNumberInput.value) - 1;
        } else {
          newValue = Number(ticketNumberInput.value);
        }
        ticketNumberInput.value  = newValue.toString();
      } else {
        this.errorMessage = this.errorMessageService.getErrorMessage("maxSelectedTicketsInCart");
      }
    }
  }

  getCart(forceReload: boolean = false) {
    this.orderService.getOrder(this.orderId, forceReload).subscribe({
      next: (order) => {
        if(order.items.length === 0) {
          window.localStorage.removeItem('orderIdEventId');
          window.localStorage.removeItem('orderId');
          window.localStorage.removeItem("orderInfo");
          sessionStorage.removeItem("orderInfoRemainingTimeToPay");
          this.cart = null;
          this.orderId = 0;
          return;
        }

        if((order.items[0].eventId !== this.eventId) || order.transactionInfo.ticketDelagation) {
          this.cart = null;
          this.cartIsLoaded = true;
          return;
        }

        this.cart = order;
        this.cartIsLoaded = true;

        if(environment.pageFolder === 'sport') {
          this.getCustomerProfile();
          sessionStorage.getItem("scrollToCart") === "true" && setTimeout(() => {
            this.cartEl?.nativeElement.scrollIntoView({ behavior: 'smooth'});
            sessionStorage.removeItem("scrollToCart");
          }, 200);
        }

        this.maxAllowedTickets = this.event.event.maxTicketsPerTransaction - this.cart?.items.length;

        this.hasPayment = order.transactionInfo.hasPayment;
        this.checkIfUserIsCombiningTwoDifferentActionsId();
        this.loader!.style.display = "none";

        setTimeout(() => {
          document.getElementById("cart")?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 350);
      }, error: error => {
        if(error.status === 401) {
          this.Services.logout();
        }
      }
    })
  }

  addToCart(group:any, sector:any, id:string, isNumbered:boolean) {
    if (this.isTransactionLocked()) {
      return;
    }

    let inputTicket:any = document.getElementById(`ticket-number-id-${group}-${sector}`) || document.getElementById(`ticket-number-modal`);
    let ticketNumber = Number(inputTicket.value);

    if(this.isLogged !== true) {
      sessionStorage.setItem("selectedSector", id);
      sessionStorage.setItem("group", group);
      sessionStorage.setItem("sector", sector);
      sessionStorage.setItem("ticketNumber", inputTicket.value);
      this.modalService.openModal(ModalNames.Login);
    } else if(this.event.action.membersExclusive && !this.isValidBarcode && (environment.connId === "1009" || environment.connId === "9")) {
      this.showModalCheckBarcode = true;
      this.addToCartData = {
        group: group,
        sector: sector,
        id: id,
        isNumbered: isNumbered
      }
      return;
    } else if(ticketNumber > 0) {
      this.loader!.style.display = "flex";
      let maxTicketsInSectorErrMsg:any = document.getElementById(`max-tickets-in-sector-${group}-${sector}`);
      let ticektNumberFromSessionStorage = sessionStorage.getItem("ticketNumber");

      if(ticektNumberFromSessionStorage) {
        ticketNumber = Number(ticektNumberFromSessionStorage);
      }

      window.sessionStorage.removeItem('selectedSector');
      window.sessionStorage.removeItem('ticketNumber');
      window.sessionStorage.removeItem('group');
      window.sessionStorage.removeItem('sector');

      let event;

      if(environment.configId === "4") {
        this.groups.map((group:any) => {
          group.sectors.map((sectorGroup:any) => {
            if(sector === sectorGroup.id) {
              event = sectorGroup;
            }
          })
        })
      } else {
        event= this.groups[group].sectors[sector];
      }

      let body:any = {
        "actionId": this.actionId,
        "eventId": this.eventId,
        "termineId": null,
        "seatsNumbered": [],
        "seatsUnnumbered": [{
          "sectorNum": event.num,
          "numberOfSeats": ticketNumber,
          "price": event.priceList.amounts[0],
          "discountId": "0"
        }]
      };

      if (this.cart === null) {
        this.http.post<any>(`${environment.apiUrl}/conn/${this.connId}/v1/orders`, body, GlobalConstants.headersCentral).subscribe({
          next: data => {
            this.errorMessage = "";
            let response:any = data;
            this.orderId = response.data;
            this.getCart(true);
            this.navigationCartService.lastOrder$ = response.data;

            if(this.isAutoSelectionTicketsModalOpen()) {
              this.modalService.closeModal(ModalNames.AutoSelectionTickets);
              this.scrollToCart();
            }
          },
          error: error => {
            if (error.status === 401) {
              this.Services.logout();
            } else if (error.error.errors[0].code === "ORA-20037") {
              this.errorMessage = this.errorMessageService.getErrorMessage("notEnoughTicketsInSector");
              this.loader!.style.display = "none";
            } else {
              this.errorMessage = this.errorMessageService.getErrorMessage("addToCartError");
              this.loader!.style.display = "none";
            }
          }
        })
        inputTicket.value = 1;
      } else if(this.maxAllowedTickets > 0) {
        this.http.patch(`${environment.apiUrl}/conn/${this.connId}/v1/orders/${this.orderId}`, body, GlobalConstants.headersCentral).subscribe({
          next: data => {
            //this.cart = null;
            this.getCart(true);
            this.showPayment = false;
            this.formFieldsKey++;

            if(this.isAutoSelectionTicketsModalOpen()) {
              this.modalService.closeModal(ModalNames.AutoSelectionTickets);
              this.scrollToCart();
            }
          },
          error: error => {
            if (error.status === 401) {
              this.Services.logout();
            } else if (error.error.errors[0].code === "ORA-20037") {
              if (maxTicketsInSectorErrMsg) {
                maxTicketsInSectorErrMsg.style.display = "block";
              }

              this.errorMessage = this.errorMessageService.getErrorMessage("notEnoughTicketsInSector");
              this.loader!.style.display = "none";
            } else {
              if (maxTicketsInSectorErrMsg) {
                maxTicketsInSectorErrMsg.style.display = "block";
              }

              this.errorMessage = this.errorMessageService.getErrorMessage("addToCartError");
              this.loader!.style.display = "none";
            }
          }
        })
        inputTicket.value = 1;
      } else if(this.maxAllowedTickets < 1) {
        if (maxTicketsInSectorErrMsg) {
          maxTicketsInSectorErrMsg.style.display = "block";
        }

        this.errorMessage = this.errorMessageService.getErrorMessage("maxTicketsInCart");
        this.loader!.style.display = "none";
      }
    }
  }

  closeModalCheckBarcode() {
    this.showModalCheckBarcode = false;
  }

  checkIsValidBarcode() {
    this.isValidBarcode = true;
    this.showModalCheckBarcode = false;
    this.addToCart(this.addToCartData.group, this.addToCartData.sector, this.addToCartData.id, this.addToCartData.isNumbered);
  }

  selectSeat(seat: any, event: MouseEvent): void {
    if (this.isDragging && this.svgPanZoomService.isZoomed) {
      return;
    }

    const element = document.getElementById(seat.rstu);
    const selectedSeatIndex = this.selectedSeats.findIndex(
      (s: { rstu: any; sectorNum: any }) =>
        s.rstu === seat.rstu && s.sectorNum === this.sectorNum
    );
    const cartItemsCount = this.cart?.items?.length ?? 0;
    let totalTickets = this.selectedSeats.length + cartItemsCount;

    if (!element) {
      return;
    }

    if (selectedSeatIndex === -1) {
      if (totalTickets >= this.event.event.maxTicketsPerTransaction) {
        this.infoMessageSeats = this.errorMessageService.getErrorMessage("maxTicketsInCart");
        return;
      }
      element.classList.add('selected-seat');
      this.selectedSeats.push({
        rstu: seat.rstu,
        sectorNum: this.sectorNum,
        discountId: '0'
      });
      totalTickets++;
    } else {
      element.classList.remove('selected-seat');
      this.selectedSeats.splice(selectedSeatIndex, 1);
      totalTickets--;
    }

    if (this.appConfig.hasSeatValidation) {
      const tempSelectedSeats = [...this.selectedSeats];
      if (!this.seatValidationService.validateSeatSelection(tempSelectedSeats, this.seats.seats)) {
        this.infoMessageSeats = this.errorMessageService.getErrorMessage("seatsBetweenSelected");
        return;
      }
    }

    if (totalTickets - 1 === this.event.event.maxTicketsPerTransaction) {
      this.infoMessageSeats = this.errorMessageService.getErrorMessage("maxTicketsInCart");
    } else {
      this.infoMessageSeats = '';
    }
  }

  addToCartNumbered() {
    if((this.infoMessageSeats && environment.configId === "4") || this.isTransactionLocked()) {
      return;
    }

    let body = {
      "actionId": this.actionId,
      "eventId": this.eventId,
      "termineId": null,
      "seatsNumbered": this.selectedSeats,
      "seatsUnnumbered": []
    };

    if(this.cart && this.cart.items.length > 0) {
      this.loader!.style.display = "flex";
      this.http.patch<any>(`${environment.apiUrl}/conn/${this.connId}/v1/orders/${this.orderId}`, body, GlobalConstants.headersCentral).subscribe({
        next: data => {
          this.getCart(true);
          this.resetZoom();
          this.showPayment = false;
          this.formFieldsKey++;

          if(environment.configId !== "4") {
            this.ifSeatsAreLoading = true;
            this.getSeats(this.sector, true);
          } else {
            this.scrollToCart();
          }

          this.selectedSeats = [];
          this.showSeats = false;
          environment.configId === "4" && this.closeSeats();
        },
        error: error => {
          if(error.status === 401) {
            this.Services.logout();
          } else if(error.error.errors[0].code === "ORA-20037") {
            this.infoMessageSeats = this.errorMessageService.getErrorMessage("error");
            this.loader!.style.display = "none";
          } else if(error.error.errors[0].code === "ORA-20006") {
            this.infoMessageSeats = this.errorMessageService.getErrorMessage("seatsAlreadyTaken");
            this.loader!.style.display = "none";
          }
        }
      })
    } else {
      this.loader!.style.display = "flex";
      this.http.post<any>(`${environment.apiUrl}/conn/${this.connId}/v1/orders`, body, GlobalConstants.headersCentral).subscribe({
        next: data => {
          let response:any = data;
          this.navigationCartService.lastOrder$ = response.data;
          this.orderId = response.data;
          this.getCart(true);
          this.resetZoom();
          this.showSeats = false;
          environment.configId === "4" && this.closeSeats();

          if(environment.configId !== "4") {
            this.ifSeatsAreLoading = true;
            this.getSeats(this.sector, true);
          } else {
            this.scrollToCart();
          }

          this.selectedSeats = [];
        },
        error: error => {
          if(error.status === 401) {
            this.Services.logout();
          } else if(error.error.errors[0].code === "ORA-20037") {
            this.infoMessageSeats = this.errorMessageService.getErrorMessage("error");
            this.loader!.style.display = "none";
          } else if(error.error.errors[0].code === "ORA-20006") {
            this.infoMessageSeats = this.errorMessageService.getErrorMessage("seatsAlreadyTaken");
            this.loader!.style.display = "none";
          } else {
            this.infoMessageSeats = this.errorMessageService.getErrorMessage("error");
            this.loader!.style.display = "none";
          }
        }
      })
    }
  }

  calculateViewBox() {
    const minX = Math.min(...this.seats.seats.map((seat: { x: number; }) => seat.x * 30 - 20));
    const minY = Math.min(...this.seats.seats.map((seat: { y: number; }) => seat.y * 30 - 20));
    this.svgWidth = Math.max(...this.seats.seats.map((seat: { x: number; }) => seat.x * 30 + 60)) - minX;
    this.svgHeight = Math.max(...this.seats.seats.map((seat: { y: number; }) => seat.y * 30 + 60)) - minY;

    this.initialViewBox = `${minX} ${minY} ${this.svgWidth} ${this.svgHeight}`;
    this.viewBox = this.initialViewBox;
    this.initializePanZoom();
  }

  getSeats(sector:any, cartIsFocused:boolean = false) {
    if(!GlobalConstants.isAuth) {
      this.modalService.openModal(ModalNames.Login);
    } else {
      this.loader!.style.display = "flex";
      this.sector = sector;
      this.sectorNum = sector.num;
      this.seats = [];
      this.http.get(`${environment.apiUrl}/conn/${this.connId}/v1/events/${this.eventId}/sectors/${sector.num}/actions/${this.actionId}/seats`).subscribe({
        next: data => {
          let response:any = data;
          this.seats = [];
          this.seats = response.data;
          let seatsPrice = response.data.prices;
          this.pricesForMembers = response.data.pricesForMembers;
          if(this.pricesForMembers) {
            this.memberPricesMap = new Map(
              this.pricesForMembers.map((p: { cksId: number; price: number; discountName: string }) => [p.cksId, p.price, p.discountName])
            );
          }

          // Check if the current sector is members exclusive
          const isSectorMembersExclusive = this.memberExclusiveMap[sector.id] || false;
          const priceColors = getPriceColors(isSectorMembersExclusive);

          seatsPrice.reduce((acc: any, priceObj: any, index: any) => {
            let id = priceObj.cksId.toString();
            let cskId_priceObj = `cskId-${id}`;
            acc[cskId_priceObj] = { fill: priceColors[index].color };
            return acc;
          }, {});

          this.seatsPrice = seatsPrice.map((priceObj: any, index: any) => {
            return {
              ...priceObj,
              color: priceColors[index].color
            };
          });

          this.seats.seats = this.seats.seats.map((seat: any) => {
            const matchingObj2 = this.seatsPrice.find((seatPrice: { cksId: any; }) => seatPrice.cksId === seat.cksId);
            if (matchingObj2) {
              return { ...seat, color: matchingObj2.color };
            } else {
              return seat;
            }
          });

          this.calculateViewBox();
          this.loader!.style.display = "none";

          if(!cartIsFocused) {
            setTimeout(() => {
              document.querySelector(`#seats`)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, 200);
          }
        }, error: (error: { status: number; }) => {
          if(error.status === 401) {
            this.Services.logout();
          }
          this.loader!.style.display = "none";
        }
      })
    }
  }

  getSeatClass(seat: any): string {
    return `cskId-${seat.cksId}`;
  }

  cancelOrder() {
    window.localStorage.removeItem('orderId');
    window.localStorage.removeItem('orderIdEventId');

    let newUrl = {
      changeUrl: true,
      url: `event/${this.connId}/${this.eventId}/${this.actionId}/${this.hashedId}`
    }
    this.Services.cancelOrder(this.orderId, false, newUrl);
  }

  openAccordionFromSvg(sector:any, sectorAll: any) {
    const isNumbered = sectorAll?.isNumbered;

    if(!GlobalConstants.isAuth) {
      this.modalService.openModal(ModalNames.Login);
    } else if(isNumbered && this.event.event.seatSelectionMethod === "SEAT_MAP") {
      this.showSeats = true;
      (environment.configId === "4") && this.modalService.openModal(ModalNames.SeatMapSelectionTickets);
      this.getSeats(sectorAll);
    } else {
      if(environment.configId === "4") {
        this.modalService.openModal(ModalNames.AutoSelectionTickets);
        this.groups.map((group:any) => {
          group.sectors.map((sector:any) => {
            if(sector.id === sectorAll.id) {
              this.selectedSectorAll = sector;
              this.selectedSectorAll.group = group;
            }
          })
        })
      } else {
        let sectorAccordion:any = document.querySelector(`[data-sectorId=${sector}]`)?.nextSibling;
        let groupAccordion: any = sectorAccordion?.parentElement?.parentElement.parentElement.parentElement.parentElement;

        sectorAccordion?.classList.add("open-accordion-sector");
        groupAccordion?.classList.add("open-accordion-group-sector");

        setTimeout(() => {
          document.querySelector(`[data-sectorId=${sector}]`)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 99);
      }
    }
  }

  changeAction(actionId:number) {
    this.loader!.style.display = "flex";
    this.actionId = actionId;
    this.getEventDetails(actionId);
  }

  compareSectorsByName(a: any, b: any) {
    const nameA = a.name.match(/(\D+|\d+)/g);
    const nameB = b.name.match(/(\D+|\d+)/g);

    for (let i = 0; i < Math.min(nameA.length, nameB.length); i++) {
      const partA = isNaN(nameA[i]) ? nameA[i] : parseInt(nameA[i], 10);
      const partB = isNaN(nameB[i]) ? nameB[i] : parseInt(nameB[i], 10);

      if (partA < partB) return -1;
      if (partA > partB) return 1;
    }

    return nameA.length - nameB.length;
  }

  toOrder() {
    //hasPayment nije dobro rjesnenje, trenutno je tako no u buducnosti ce se hasPayment trebati pobrisati i koristiti s drugim parametrima
    let actionId = this.hasPayment ? ACTION_ID.NORMAL : ACTION_ID.FREE_TICKET;
    this.actionId === ACTION_ID.SUBSCRIBER_TICKET && (actionId = ACTION_ID.SUBSCRIBER_TICKET);
    this.router.navigate([`order/${this.connId}/${this.eventId}/${this.orderId}/${actionId}`]);
  }

  initializePanZoom() {
    setTimeout(() => {
      this.svgPanZoomService.initialize(
        this.svgElement?.nativeElement,
        this.panzoomContainer.nativeElement
      );

      this.ifSeatsAreLoading = false;
    }, 200);
  }

  zoomIn() {
    this.svgPanZoomService.zoomIn();
  }

  zoomOut() {
    this.svgPanZoomService.zoomOut(this.initialViewBox);
  }

  resetZoom() {
    this.svgPanZoomService.resetZoom(this.initialViewBox);
  }

  onWheel(event: WheelEvent) {
    this.svgPanZoomService.onWheel(event, this.initialViewBox);
  }

  startPan(event: MouseEvent) {
    if (event.button === 0) {
      this.isPanning = true;
      this.svgPanZoomService.startPan(event);
    } else {
      this.isDragging = false;
    }
  }

  pan(event: MouseEvent) {
    if (this.isPanning) {
      this.isDragging = true;
      this.svgPanZoomService.pan(event);
    } else {
      this.isDragging = false;
    }
  }

  stopPan() {
    this.isPanning = false;
    this.isDragging = false;
    this.svgPanZoomService.stopPan();
  }

  handleTouchStart(event: TouchEvent) {
    if (event.touches.length === 1) {
      this.svgPanZoomService.startPan(event.touches[0]);
    } else if (event.touches.length === 2) {
      if(this.svgPanZoomService.isZoomed) {
        event.preventDefault();
      }

      this.startZoom(event);
    }
  }

  handleTouchMove(event: TouchEvent) {
    if (event.touches.length === 1) {
      this.svgPanZoomService.pan(event.touches[0]);

      if(this.svgPanZoomService.isZoomed) {
        event.preventDefault();
      }
    } else if (event.touches.length === 2) {
      event.preventDefault();
      this.zoomWithPinch(event);
    }
  }

  handleTouchEnd(event: TouchEvent) {
    if (event.touches.length === 0) {
      this.svgPanZoomService.stopPan();
    }
  }

  private startZoom(event: TouchEvent) {
    this.initialDistance = this.getDistanceBetweenTouches(event);
  }

  private zoomWithPinch(event: TouchEvent) {
    const currentDistance = this.getDistanceBetweenTouches(event);
    const zoomFactor = currentDistance / this.initialDistance;

    const rect = this.svgElement.nativeElement.getBoundingClientRect();
    const centerX = (event.touches[0].clientX + event.touches[1].clientX) / 2 - rect.left;
    const centerY = (event.touches[0].clientY + event.touches[1].clientY) / 2 - rect.top;

    this.svgPanZoomService.applyZoom(zoomFactor, centerX, centerY);
  }

  private getDistanceBetweenTouches(event: TouchEvent) {
    const touch1 = event.touches[0];
    const touch2 = event.touches[1];
    const dx = touch2.clientX - touch1.clientX;
    const dy = touch2.clientY - touch1.clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  changeEventSectorsView(view: string) {
    this.showSectorsView = view === 'sectors';
  }

  changeShowPayment(show: boolean) {
    this.showPayment = show;
  }

  closeSeats() {
    this.modalService.closeModal(this.modalNamesEnum.AutoSelectionTickets);
    this.selectedSeats = [];
    this.resetZoom();
    this.showSeats = false;
  }

  setEmptyCart() {
    this.cart = null;
  }

  scrollToCart(): void {
    setTimeout(() => {
      this.cartEl?.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 300);
  }

  private showNotificationModal(): void {
    const notificationConfig = getNotificationConfig(this.router.url, 'TICKETS');
    this.showNotification = notificationConfig.show;
    this.bodyText = notificationConfig.bodyTextKey;
  }

  ngOnDestroy() {
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
  }

  private buildMemberExclusiveMap(): void {
    const isEventMembersExclusive = !!this.eventAction?.membersExclusive;
    this.memberExclusiveMap = {};

    this.groups?.forEach((group: { sectors: any[] }) => {
      const sectors = (group.sectors || []).sort((a: any, b: any) => a.ord - b.ord);

      sectors.forEach((sector: any) => {
        if (isEventMembersExclusive || sector?.membersExclusive) {
          this.memberExclusiveMap[sector.id] = true;
        }
      });
    });
  }

  private computeLegendFlags(): void {
    const sectors = this.svg?.sectors ?? [];

    if (!Array.isArray(sectors) || sectors.length === 0) {
      this.showLegendUnavailable = false;
      this.showLegendAvailable = false;
      this.showLegendMembers = false;
      return;
    }

    const result = sectors.reduce(
      (acc: { unavailable: boolean; available: boolean; members: boolean }, sector: any) => {
        if (acc.unavailable && acc.available && acc.members) {
          return acc;
        }

        if (sector?.active === false) {
          acc.unavailable = true;
          return acc;
        }

        if (sector?.active === true) {
          if (this.memberExclusiveMap[sector?.id]) {
            acc.members = true;
          } else {
            acc.available = true;
          }
        }

        return acc;
      },
      { unavailable: false, available: false, members: false }
    );

    this.showLegendUnavailable = result.unavailable;
    this.showLegendMembers = result.members;
    this.showLegendAvailable = result.available;
  }
}
